import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Mixpanel } from '../../config/Mixpanel'
import constants from '../PersonaliseLessons/utilities/constants'
import { useDispatch } from 'react-redux'
import { updateCourseName } from '../../redux/personaliseLessons/courseListSlice'
import { checkTrialPeriod } from '../../redux/personaliseLessons/nameSlice'
import { toast } from 'react-toastify'


const CourseDropDown = ({ courseList, courseName, setCourseName, email, showDropDown, setShowDropDown }) => {

    const [courseClicked, setCourseClicked] = useState(Array(courseList?.length > 0 ? courseList?.length + 1 : 0).fill(false))
    const navigate = useNavigate()
    const dispatch = useDispatch()
    
    
    const handleClick = async (index) => {
        try {
            Mixpanel.track(constants.Mixpanel.COURSE_LIST_SELECT_COURSE_FROM_DROPDOWN)
            setCourseClicked((prevCourseClicked) => {
                const updatedShowLessons = [...Array(prevCourseClicked?.length).fill(false)];
                updatedShowLessons[index] = true;
                return updatedShowLessons;
            })
            dispatch(updateCourseName(courseList?.[index]))
            setTimeout(() => setShowDropDown(!showDropDown), 300)
            await dispatch(checkTrialPeriod({ subject: courseList?.[index], email})).unwrap()
            navigate(`/personalise/${encodeURIComponent(courseList?.[index])}`)
        } catch (error) {
            console.log(error.message);
            toast.error("Something went wrong! Please try again later.")
            navigate(-1, { replace: true })
            return
        }
    }

    return (
        <>
            <div className='relative'>
                <div className={`${showDropDown ? 'border' : 'border-2'} cursor-pointer border-[#5E9BD8] mt-1.5 px-3 py-2 rounded-lg flex items-center`} onClick={() => setShowDropDown(!showDropDown)}>
                    <p className='flex-1 text-2xl font-semibold'>{courseName}</p>
                    {!showDropDown ? <FontAwesomeIcon icon={faChevronDown} /> : <FontAwesomeIcon icon={faChevronUp}/>}   
                </div>
                <div className={`${showDropDown ? 'block' : 'hidden'} w-full mt-2 rounded-lg`} style={{boxShadow: '0px 0px 24px 0px #FFFFFF33'}}>
                    <div className='w-full border border-[#5E9BD8] rounded-lg'>
                        {courseList?.map((item, index) => (
                            <div className={`w-full p-4 cursor-pointer ${index === 0 ? 'rounded-t-lg' : '-mt-0.5'} ${courseClicked[index] ? 'bg-[#2D4F71] text-[#5E9BD8]' : ''}`} key={index} onClick={()=>handleClick(index)}>
                                {item}
                            </div>
                        ))}
                        <div className={`text-center w-full p-4 rounded-b-lg -mt-0.5 ${courseClicked[courseClicked.length] ? 'bg-[#2D4F71] text-[#5E9BD8]' : ''}`} onClick={(e) => {
                            e.stopPropagation()
                            localStorage.setItem('courseFromAddNew', JSON.stringify(true))
                            setTimeout(() => navigate("/"), 500)
                            }}>
                            <p className='underline text-[#71A8DF]'><span className='cursor-pointer'>+Add New Course</span></p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CourseDropDown
